import { $_app_server } from '@/_helpers'
import store from '@/store'

export const authService = {
  auth,
  regPublicKey,
  restorePassword,
  registerUser,
  uuidv4,
  logOut,
  createWebAuth,
  getWebAuth,
  checkAuth,
  getProfileInfo,
  kiddiePath
}

function checkAuth() {
  return $_app_server.get(`/api-checkauth`).then((response) => {
    return response
  })
}

function getProfileInfo() {
  return $_app_server.get(`/api-getProfileinfo`).then((response) => {
    return response
  })
}

function createWebAuth() {
  const clientid = store.state?.infoClient?.infoClient?.logininfo?.accinfo?.client_id
  if (!clientid) return
  let devId = localStorage.getItem('devId')

  if (!devId) {
    devId = uuidv4()
    localStorage.setItem('devId', devId)
  }

  let form = new FormData()
  form.append('clientId', clientid)
  form.append('devId', devId)

  return $_app_server
    .post('/icard-authchallenge', form)
    .then((data) => registerWebAuth(data.data.challenge, clientid, devId))
    .then((data) => localStorage.setItem('authId', buf2Base64(data.rawId)))
}

function getWebAuth() {
  let base64RawId = localStorage.getItem('authId')
  let form = new FormData()
  form.append('authId', base64RawId)
  form.append('devId', localStorage.getItem('devId'))

  return $_app_server.post('/icard-authchallenge', form).then((data) => verifyWebAuth(data.data.challenge, base2buf(base64RawId)))
}

function registerWebAuth(challenge, clientId, devId) {
  const credentialArgs = {
    publicKey: {
      rp: { id: window.location.host, name: window.location.host },

      user: {
        id: new Uint8Array(16),
        name: '',
        displayName: '',
      },

      pubKeyCredParams: [
        { type: 'public-key', alg: -7 },
        { type: 'public-key', alg: -257 },
      ],
      attestation: 'none',
      authenticatorSelectionCriteria: {
        attachment: 'platform',
        requireResidentKey: false,
        userVerification: 'required',
      },
      authenticatorSelection: {
        authenticatorAttachment: 'platform',
      },
      timeout: 60000,
      challenge: new TextEncoder().encode(challenge).buffer,
    },
  }

  return navigator.credentials.create(credentialArgs).then((cred) => {
    console.log('NEW CREDENTIAL', cred)
    let form = new FormData()
    form.append('mode', 4)
    form.append('state', '1')
    form.append('devId', devId)
    form.append('clientId', clientId)
    form.append('authId', buf2Base64(cred.rawId))
    form.append('attestationObject', buf2Base64(cred.response.attestationObject))
    form.append('clientDataJSON', buf2Base64(cred.response.clientDataJSON))

    return $_app_server.post('/api-kiddieauth', form).then(() => cred)
  })
}

function verifyWebAuth(challenge, rawId) {
  let options = {
    publicKey: {
      timeout: 60000,
      challenge: new TextEncoder().encode(challenge).buffer,
      allowCredentials: [
        {
          id: rawId,
          transports: ['internal'],
          type: 'public-key',
        },
      ],
    },
  }

  return navigator.credentials.get(options).then((cred) => {
    console.log('NEW ATTESTETION', cred)

    let form = new FormData()
    form.append('mode', 5)
    form.append('state', '1')
    form.append('devId', localStorage.getItem('devId'))
    form.append('authId', buf2Base64(cred.rawId))
    form.append('userHandle', buf2Base64(cred.response.userHandle))
    form.append('authenticatorData', buf2Base64(cred.response.authenticatorData))
    form.append('clientDataJSON', buf2Base64(cred.response.clientDataJSON))
    form.append('signature', buf2Base64(cred.response.signature))

    return $_app_server.post('/api-kiddieauth', form).then((data) => data)
  })
}

const buf2Base64 = (arrayBuffer) => btoa(String.fromCharCode(...new Uint8Array(arrayBuffer)))

const base2buf = (base64) => Uint8Array.from(atob(base64), (c) => c.charCodeAt(0)).buffer

function auth(login, password, mode, pubkey) {
  var data = new FormData()

  if ('serviceWorker' in navigator) {
    let devId = localStorage.getItem('devId')
    if (!devId) {
      devId = uuidv4()
      localStorage.setItem('devId', devId)
    }
    data.append('deviceId', devId)
    data.append('pwa', 1)
  }

  data.append('mode', mode)

  if (mode == 2) {
    data.append('pushToken', '')
    data.append('hashKey', window.btoa(pubkey))
  }

  if (mode == 1 && login && password) {
    data.append('login', login)
    data.append('pass', password)
    data.append('state', '1')
  }
  
  return $_app_server.post(`/api-kiddieauth`, data).then((response) => {
    return response
  })
}

function regPublicKey(pKey, devType) {
  if (!pKey) return
  let devId = localStorage.getItem('devId')
  var data = new FormData()
  data.append('devid', devId)
  data.append('devType', devType)
  data.append('pubkey', window.btoa(pKey))
  return $_app_server.post(`/icard-pubkey`, data).then((response) => {
    return response
  })
}

function logOut() {
  return $_app_server.get(`/api/logout`).then((response) => {
    return response
  })
}

function uuidv4() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
  )
}

function restorePassword(form) {
  var data = new FormData()
  data.append('account', form.account)

  if (form.expires) {
    form.expires = form.expires.split('')
    form.expires.splice(2, 0, '/')
    form.expires = form.expires.join('')
    data.append('expires', form.expires)
  }

  data.append('code', form.code)
  data.append('serial', form.serial)
  data.append('number', form.number)

  if (form.otpPass) {
    data.append('otpPass', form.otpPass)
  }

  if (form.pass) {
    data.append('pass', form.pass)
  }

  if (form.passdubl) {
    data.append('passdubl', form.passdubl)
  }

  if (form.pass && form.passdubl) {
    return $_app_server.post(`/api/restore/uuid/${uuidv4()}?state=2`, data).then((response) => {
      return response
    })
  }

  if (form.otpPass) {
    return $_app_server.post(`/api/restore/uuid/${uuidv4()}?state=1`, data).then((response) => {
      return response
    })
  }

  return $_app_server.post(`/api/restore/uuid/${uuidv4()}`, data).then((response) => {
    return response
  })
}

function registerUser(form) {
  var data = new FormData()
  data.append('account', form.account)

  if (form.expires) {
    form.expires = form.expires.split('')
    form.expires.splice(2, 0, '/')
    form.expires = form.expires.join('')
    data.append('expires', form.expires)
  }

  data.append('code', form.code)
  data.append('serial', form.serial)
  data.append('phone', form.phone)
  data.append('number', form.number)

  if (form.otpPass) data.append('otpPass', form.otpPass)
  if (form.pass) data.append('pass', form.pass)
  if (form.passdubl) data.append('passdubl', form.passdubl)
  if(form.devId) data.append('devId', form.devId)

  if (form.pass && form.passdubl) {
    return $_app_server.post(`/api/register/uuid/${uuidv4()}?state=2`, data).then((response) => {
      return response
    })
  }

  if (form.otpPass) {
    return $_app_server.post(`/api/register/uuid/${uuidv4()}?state=1`, data).then((response) => {
      return response
    })
  }

  return $_app_server.post(`/api/register/uuid/${uuidv4()}`, data).then((response) => {
    return response
  })
}

function kiddiePath() {
  return $_app_server.post(`/api-kiddiePath`).then((response) => {
    return response
  })
}
